export default "__VITE_ASSET__Clk4f70T__"